import React, { MouseEvent } from 'react';
import clsx from 'clsx';
import styles from '../products.module.scss';

const LinkButton: React.FC<{
  name: string;
  href: string;
  onClick: (e?: MouseEvent<HTMLAnchorElement>) => void;
}> = ({ name, href, onClick }) => {
  return (
    <a
      className={clsx('vc-btn vc-btn--outline', styles.ordersSales__mainLeft__button)}
      href={href}
      rel={'noreferrer'}
      target={'_blank'}
      onClick={onClick}
    >
      {name}
    </a>
  );
};

export default LinkButton;
